import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ReporteParaEmbarqueView } from '../components/ReporteParaEmbarqueView'

class ReporteParaEmbarque extends Component {
  render () {
    return <ReporteParaEmbarqueView />
  }
}

const withRedux = connect(null, null)

export default withRedux(ReporteParaEmbarque)
